import React from 'react';
import { Image, Platform } from 'react-native';
import CachedImage from 'react-native-expo-cached-image';
import Storage from './Storage';

const CachedImageWrapper = (props) => {
  const [rtJWT, setRtJWT] = React.useState(null);

  React.useEffect(() => {
    (async () => {
      const rtJWT = await Storage.getItem('rtJWT');
      setRtJWT(rtJWT);
    })()
  }, []);

  let newProps = { ...props };
  let source = { ...props.source };
  // source.headers = { crossorigin: 'use-credentials' };
  // source.headers = { 'Authorization': `Bearer ${rtJWT}`, };
  source.uri += `?${rtJWT}`;
  newProps.source = source;
  // console.log('newProps: ', newProps);

  return <Image {...newProps} />

  // if (Platform.OS === 'web') {
  //   return <Image {...newProps} />
  // }else{
  //   return <CachedImage {...newProps} />
  //   // return <CachedImage {...props} />
  //   // return <Image {...newProps} />
  // }
}

export default CachedImageWrapper;